import * as Moment from 'moment';

export function getGTZHochrechnung(values: any[]): any {
    const jahrMax: number = Moment().year();
    const valueMap: any = {};
    const jahrMin = 2010;
    // console.log('GT-V', values);
    if (Array.isArray(values)) {
        values.forEach((item: any) => {
            const monat = item.monat;
            const jahr = item.jahr;
            if (!valueMap[jahr]) {
                valueMap[jahr] = {};
            }
            valueMap[jahr][monat] = item;
        });
    }
    // Alle Jahre durchgehen
    for (let jahr = jahrMin; jahr <= jahrMax; jahr++) {
        if (!valueMap[jahr]) {
            valueMap[jahr] = {};
        }
        for (let monat = 1; monat <= 12; monat++) {
            if (valueMap[jahr][monat]) {
                valueMap[jahr][monat].isReal = true;
            } else if (valueMap[jahr - 1] && valueMap[jahr - 1][monat]) {
                valueMap[jahr][monat] = { ...valueMap[jahr - 1][monat] };
                valueMap[jahr][monat].isReal = false;
            } else {
                valueMap[jahr][monat] = {};
            }
            const days = Moment(jahr + '-' + monat, 'YYYY-MM').daysInMonth();
            valueMap[jahr][monat].days = days;
            if (valueMap[jahr][monat].gtz && valueMap[jahr][monat].gtz > 0) {
                valueMap[jahr][monat].gtz_day = valueMap[jahr][monat].gtz / days;
            } else {
                valueMap[jahr][monat].gtz_day = 0;
            }
            // GTZ -> Langjähriges Mittel
            if (valueMap[jahr][monat].mittel_10_jahre && valueMap[jahr][monat].mittel_10_jahre > 0) {
                valueMap[jahr][monat].mittel_day = valueMap[jahr][monat].mittel_10_jahre / days;
            } else {
                valueMap[jahr][monat].mittel_day = 0;
            }
            // console.log(jahr, monat, valueMap[jahr][monat]);
        }
    }
    return valueMap;
}
